import { RunGroupFormValues } from "@features/run/RunGroupDialog/RunGroupForm"
import { FormControl, FormHelperText, TextField } from "@mui/material"
import { DatePicker } from "@mui/x-date-pickers"
import { getErrorMessage } from "@utils/form"
import { Controller, useFormContext } from "react-hook-form"

export const RunGroupFieldStartDate = () => {
  const {
    control,
    formState: { errors },
  } = useFormContext<RunGroupFormValues>()

  return (
    <Controller
      name="start_date"
      control={control}
      render={({ field }) =>
        field.value === "rolling" ? (
          <TextField
            error={Boolean(errors[field.name])}
            helperText={getErrorMessage(errors, field.name)}
            label="Start date"
            variant="standard"
            disabled
            {...field}
          />
        ) : (
          <FormControl variant="standard" error={Boolean(errors[field.name])}>
            <DatePicker
              label="Start date"
              format="yyyy-MM-dd"
              slotProps={{ textField: { variant: "standard" } }}
              disabled
              {...field}
            />
            <FormHelperText error>{getErrorMessage(errors, field.name)}</FormHelperText>
          </FormControl>
        )
      }
    />
  )
}
